/**
 * 低库存「去采购」预填：经发起申请页打开表单。
 * 使用 location.state.procurementPrefill 传递。
 */
export type ProcurementPrefillChannel = 'internal' | 'merchant';

export type ProcurementPrefillState = {
  category: '耗材申请' | '试剂申请';
  channel: ProcurementPrefillChannel;
  merchantId?: string;
  merchantName?: string;
  /** 原低库存提醒对应的已通过申请 ID */
  sourceSuggestionApplicationId: string;
  title?: string;
  reason?: string;
  priority?: '普通' | '紧急' | '特急';
  consumableProject?: {
    category?: string;
    image?: string;
    name: string;
    model: string;
    brand?: string;
    unit: string;
    purchaseChannel?: '网购' | '其他';
    purchaseLink?: string;
    supplier?: string;
    amount: string;
    price?: string;
    total?: string;
    usage?: string;
  };
  reagentProject?: {
    category?: string;
    image?: string;
    name?: string;
    cas: string;
    catalogNumber?: string;
    vendor: string;
    specification: string;
    unit: string;
    purchaseChannel?: string;
    amount: string;
    price?: string;
    total?: string;
    usage?: string;
  };
};

export const PROCUREMENT_PREFILL_STATE_KEY = 'procurementPrefill';
